/** 区块 Props Type */
export const BlockPropsType = {
  input: 'input',
  textarea: 'textarea',
  number: 'number',
  color: 'color',
  multiColor: 'multiColor',
  select: 'select',
  table: 'table',
  switch: 'switch',
  columnInput: 'columnInput'
}
